/* eslint-disable react/prop-types */
import React, { useRef, useState, useCallback } from "react";
import { Line } from "react-chartjs-2";
import CustomTooltip from "app/common/chart/CustomTooltipComponent";
import { Typography, useMediaQuery } from "@material-ui/core";
import { nFormatter } from "lib/utils";
import _ from "lodash";

// const useStyles = makeStyles(() => ({
//   arrowPercentage: {
//     color: "#939393",
//     marginRight: "1px",
//   },
//   containerRow: {
//     display: "flex",
//     alignItems: "center",
//     fontSize: "12px",
//   },
// }));

function DailyPromotionsWeigthChartComponent({
  data,
  scenarioEstimationEventPerDate,
}) {
  const refs = useRef();
  // const classes = useStyles();
  const [tooltipProps, setTooltipProps] = useState({});
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const setPositionAndData = (payload) => {
    setTooltipProps({
      top: payload.top,
      left: payload.left,
      position: "absolute",
      tooltipModel: payload.tooltipModel,
      showTooltip: true,
      width: 200,
    });
  };

  const hide = () => {
    setTooltipProps({
      ...tooltipProps,
      showTooltip: false,
    });
  };

  const chartOptions = {
    scales: {
      xAxes: [
        {
          id: "Time",
          offset: true,
          gridLines: {
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            padding: 10,
            beginAtZero: false,
            autoSkip: true,
            maxTicksLimit: 31,
            maxRotation: isSmallScreen ? 45 : 0,
            callback: React.useCallback((value) => {
              const numberValue = Number(value.substring(7, 9));
              if (numberValue % 5 === 0) {
                return `${Number(value.substring(7, 9))}th`;
              }
              if (numberValue === 1) {
                return "1st";
              }
              return "";
            }, []),
          },
        },
      ],
      yAxes: [
        {
          id: "daily-weight",
          scaleLabel: {
            labelString: `Daily Weight`,
            display: false,
          },
          gridLines: {
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
          position: "left",
        },
        {
          id: "price-out",
          display: false,
          scaleLabel: {
            labelString: `Price Out`,
            display: false,
          },
          gridLines: {
            drawOnChartArea: true,
            drawTicks: false,
          },
          ticks: {
            padding: 10,
            beginAtZero: true,
            autoSkip: true,
            maxTicksLimit: 6,
            maxRotation: 0,
            minRotation: 0,
          },
          position: "right",
        },
      ],
    },
    layout: {
      padding: {
        left: 10,
        right: 15,
        top: 15,
        bottom: 15,
      },
    },
    legend: {
      display: false,
    },
    tooltips: {
      enabled: false,
      intersect: isSmallScreen,
      mode: "nearest",
      axis: "x",
      custom: useCallback((tooltipModel) => {
        if (tooltipModel.opacity === 0) {
          hide();
          return;
        }

        const chart = refs.current.chartInstance;
        const { canvas } = chart.ctx;

        if (canvas) {
          const position = canvas.getBoundingClientRect();

          // set position of tooltip
          const left =
            tooltipModel.caretX <= chart.width / 2
              ? position.left / 2 + tooltipModel.caretX + 60
              : position.left / 2 + tooltipModel.caretX - 240;
          const top = tooltipModel.caretY + 80;

          setPositionAndData({ top, left, tooltipModel });
        }
      }, []),
    },
    responsive: true,
    maintainAspectRatio: false,
  };
  return (
    <>
      {tooltipProps.showTooltip ? (
        <CustomTooltip
          tooltipProps={tooltipProps}
          scenarioEstimationEventPerDate={scenarioEstimationEventPerDate}
          items={_.map(
            tooltipProps.tooltipModel.dataPoints,
            (dataPoint, dataPointIdx) => {
              return {
                content: (
                  <div>
                    <Typography variant="body2">
                      {
                        refs.current.chartInstance.data.datasets[
                          dataPoint.datasetIndex
                        ].label
                      }
                    </Typography>
                    <Typography variant="caption">
                      {dataPoint.value
                        ? `${nFormatter(parseFloat(dataPoint.value))} ${
                            refs.current.chartInstance.data.datasets[
                              dataPoint.datasetIndex
                            ].unit || ""
                          }`
                        : ""}
                    </Typography>
                  </div>
                ),
                borderStyle: {
                  border:
                    dataPointIdx === 0
                      ? `2px dashed ${
                          refs.current.chartInstance.data.datasets[
                            dataPoint.datasetIndex
                          ].hoverBorderColor
                        }`
                      : `2px solid ${
                          refs.current.chartInstance.data.datasets[1]
                            .backgroundColor[dataPoint.index]
                        }`,
                },
              };
            }
          )}
          tooltipData={{
            title: `${
              refs.current.chartInstance.data.datasets[
                tooltipProps.tooltipModel.dataPoints[0].datasetIndex
              ].data[tooltipProps.tooltipModel.dataPoints[0].index].x
            }`,
          }}
        />
      ) : null}
      <Line ref={refs} data={data} options={chartOptions} />
    </>
  );
}

export default DailyPromotionsWeigthChartComponent;
